import React from 'react';

import { useState, useRef, useEffect, useContext } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { Button, Form, Col, Row, Modal } from 'react-bootstrap';

import AppContext from '../../AppContext';
import Alert from '../Alert';

import { email, salutation, firstName, lastName, phoneNo, username } from '../Schema';

import MandatoryFieldNotice from '../MandatoryFieldNotice';

const schema = yup.object().shape({
    salutation: salutation,
    firstname: firstName,
    lastname: lastName,
    email: email,
    phone: phoneNo,
    username: username,
});


const PersonModal = ({ modal, closeModal, person, onSubmit, message, editMode }) => {
    const { Salutations } = useContext(AppContext);

    const formRef = useRef();

    useEffect(() => {
        if (!person) return;
        formRef.current.setFieldValue("salutation", person.SalutationID || 1);
        formRef.current.setFieldValue("title", person.Title || "");
        formRef.current.setFieldValue("firstname", person.FirstName || "");
        formRef.current.setFieldValue("lastname", person.LastName || "");
        formRef.current.setFieldValue("phone", person.PhoneNo || "");
        formRef.current.setFieldValue("email", person.Email || "");
        formRef.current.setFieldValue("username", person.Username || "");

        formRef.current.setFieldValue("admin", person.IsAdmin);
    }, [person]);

    return (
        <Modal centered show={modal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Benutzer {editMode ? "bearbeiten" : " hinzufügen"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message && <Alert type="error" message={message} />}

                <Formik
                    innerRef={(f) => (formRef.current = f)}
                    validationSchema={schema}
                    onSubmit={(values) => {
                        onSubmit(values, editMode);
                    }}
                    initialValues={{
                        salutation: '1',
                        title: '',
                        firstname: '',
                        lastname: '',
                        phone: '',
                        email: '',
                        username: '',
                        admin: false,
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => {
                        return (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3" controlId="salutation">
                                    <Form.Label className="required" column sm={6}>Anrede</Form.Label>
                                    <Col sm={6}>
                                        <Form.Select enabled="true" isInvalid={errors.salutation && touched.salutation} name="salutation" value={values.salutation} onBlur={handleBlur} onChange={handleChange}>
                                            {Salutations.map((option) => {
                                                return (
                                                    <option key={option.SalutationID} value={option.SalutationID}>
                                                        {option.Description}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.salutation}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="title">
                                    <Form.Label column sm={6}>Titel</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.title && touched.title} type="text" name="title" value={values.title} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.title}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="firstname">
                                    <Form.Label className="required" column sm={6}>Vorname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.firstname && touched.firstname} type="text" name="firstname" value={values.firstname} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.firstname}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="lastname">
                                    <Form.Label className="required" column sm={6}>Nachname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.lastname && touched.lastname} type="text" name="lastname" value={values.lastname} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.lastname}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="email">
                                    <Form.Label className="required" column sm={6}>E-Mail-Adresse</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.email && touched.email} type="text" name="email" value={values.email} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="username">
                                    <Form.Label className="required" column sm={6}>Benutzername</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.username && touched.username} type="text" name="username" value={values.username} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.username}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="phone">
                                    <Form.Label column sm={6}>Telefon</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.phone && touched.phone} type="text" name="phone" value={values.phone} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.phone}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="admin">
                                    <Col sm={6} className="col-form-label">
                                        <Form.Label sm={6}>Admin</Form.Label>
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Check aria-label={"Ist Admin?"} name="admin" checked={values.admin} value="1" checked={values.admin} onBlur={handleBlur} onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <MandatoryFieldNotice />
                            </Form>
                        )
                    }}
                </Formik>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Abbrechen
                </Button>
                <Button variant="primary" onClick={() => formRef.current.submitForm()}>
                    {editMode && "Speichern"}
                    {!editMode && "Hinzufügen"}
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default PersonModal;